import App from "./app";
import Support from "./support";
import CustomizerModule from "./customizer_module";

const routes = [
  {
    type: "collapse",
    key: "app",
    route: "/app",
    component: <App />,
  },
  {
    type: "collapse",
    key: "support",
    route: "/support",
    component: <Support />,
  },
   {
    type: "collapse",
    key: "customizer_module",
    route: "/customizer_module",
    component: <CustomizerModule />,
  },
];

export default routes;
